// editare de user de catre admin
import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
// import textfield pt user si parola
import TextField from "@mui/material/TextField";
import withRouter from "../../../components/routerhoc";
import axios from "axios";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// css
import "../../../css/style.css";
import theme from "../../../css/theme";
import DeleteIcon from "@mui/icons-material/Delete";
// const apiURL = "http://cursa.app.local:5001";
const columns = [
  { field: "user_id", headerName: "ID", width: 70 },
  { field: "user_name", headerName: "user_name", width: 130 },
  { field: "user_type", headerName: "user_type", width: 90 },
];

const UserDataTable = props => {
  const { rows } = props;
  const loading = props.loading;
  const selectRow = props.selectRow;

  return (
    <div style={{ height: 400, width: "100%", color: "white" }}>
      <DataGrid
        className="data-table-container"
        rows={rows}
        columns={columns}
        pageSize={50}
        rowsPerPageOptions={[50]}
        checkboxSelection
        loading={loading}
        onSelectionModelChange={selectRow}
      />
    </div>
  );
};

const Users = props => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const currentUser = useSelector(state => state.auth);
  const { user_id, user_type } = currentUser;
  //new user
  const [newUserName, setNewUserName] = useState("");
  const [newUserType, setNewUserType] = useState("");
  const [newUserPassword, setNewUserPassword] = useState("");
  const [message, setMessage] = useState(false);
  const [lastUserID, setlastUserID] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);

  useEffect(() => {
    if (user_type === "ECHIPA" || user_type === "GUEST") {
      console.log(`usertype in if = `, user_type);
      navigate("/login");
    }
    getUsersList();
  }, []);

  const getUsersList = () => {
    axios
      .get(`/api/admin/list`)
      .then(response => {
        const responseArr = response.data;

        if (responseArr.length > 0) {
          setLoading(false);
        }
        responseArr.forEach(element => {
          element.id = element.user_id;
          console.log(element);
        });
        setRows(() => responseArr);
        console.log(`RESPONSE LA LIST USERS: `, responseArr);
      })
      .catch(error => {
        console.error(`Error la axios /api/user/list`, error);
      });
  };

  const onAddUser = () => {
    const newUser = {
      user_name: newUserName,
      user_type: newUserType,
      user_password: newUserPassword,
    };

    if (newUserName !== "" && newUserType !== "" && newUserPassword !== "") {
      false &&
        console.log(
          `saved new state: => newUserName: ${newUserName}, newUserType:  ${newUserType} , newUserPassword: ${newUserPassword}`
        );

      axios
        .post(`/api/admin/add`, newUser)
        .then(response => {
          console.log(`NEWUSER= `, response.data);
          setlastUserID(response.data);
          setMessage(true);
          setNewUserName("");
          setNewUserType("");
          setNewUserPassword("");
          getUsersList();
        })
        .catch(error => {
          console.error(`Axios error /api/admin/add : `, error);
        });
    } else {
      console.log(`NEW USER INCORRECT`);
    }
  };
  const handleName = event => {
    setNewUserName(event.target.value);
  };

  const handleType = event => {
    setNewUserType(event.target.value);
  };

  const handlePassword = event => {
    setNewUserPassword(event.target.value);
  };

  const onCancel = () => {
    setMessage(false);
    setNewUserName("");
    setNewUserType("");
    setNewUserPassword("");
  };

  const selectRow = ids => {
    const selectedIDs = new Set(ids);
    const selectedRows = rows.filter(row => selectedIDs.has(row.id));
    setSelectedRows(selectedRows);
    console.log(`selected users : `, selectedRows);
  };

  const onDelete = () => {
    selectedRows.forEach(user => {
      axios
        .delete(`/api/admin/delete/${user.user_id}`)
        .then(response => {
          console.log(`deleted user`, response);
          getUsersList();
        })
        .catch(error => {
          console.error(`Axios error /api/admin/delete : `, error);
        });
    });
  };

  const onReturn = () => {
    navigate(`/login`);
  };

  return (
    <div className="edit-member-container">
      {message && <div>A fost adaugat userul {lastUserID};</div>}

      <div className="text-fields">
        <div>
          <TextField
            className="textfield"
            required
            id="outlined-required"
            label="Add User"
            name="user_name"
            value={newUserName}
            onChange={handleName}
          />
        </div>
        <div>
          <TextField
            className="textfield"
            required
            id="outlined-required"
            label="New Type"
            name="user_type"
            value={newUserType}
            onChange={handleType}
          />
        </div>
        <div>
          <TextField
            className="textfield"
            required
            id="outlined-required"
            label="New Password"
            name="user_password"
            value={newUserPassword}
            onChange={handlePassword}
          />
        </div>
      </div>
      <div>
        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onAddUser}>
          Add user
        </Button>

        <Button className="admin-buttons" variant="contained" theme={theme} type="submit" onClick={onCancel}>
          Cancel
        </Button>

        <Button className="admin-buttons" theme={theme} variant="contained" type="submit" onClick={onReturn}>
          Return
        </Button>

        <Button
          className="admin-buttons"
          variant="contained"
          theme={theme}
          type="submit"
          onClick={onDelete}
          startIcon={<DeleteIcon />}
        >
          Delete User
        </Button>
      </div>

      <div className="data-table-wrapper">
        <UserDataTable rows={rows} loading={loading} selectRow={selectRow} />
      </div>
    </div>
  );
};

export default withRouter(Users);
